import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { LuxButton } from "@/components/LuxButton";
import { Check, X } from "lucide-react";
import { IMG } from "@/data/brand";

const notAllowed = [
  "Hats", "Sweatpants", "Athletic Attire", "T-Shirts",
  "Excessively Baggy Clothing", "Excessively Revealing Clothing",
  "Clothing that Reveals Undergarments", "Clothing in Disrepair (Ripped Jeans, etc.)",
];
const suggested = ["Button-Down Shirts", "Suits", "Blazers", "Skirts", "Dresses", "Dress Pants"];

const DressCodePage = () => (
  <main data-testid="dress-code-page">
    <PageHero kicker="About" title={["Dress Code"]} image={IMG.fireplace} height="h-[50vh]" />
    <section className="bg-[#f8f5f0] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <Reveal>
          <p className="font-serif italic text-2xl md:text-3xl text-[#b08d4a] text-center">Business casual is required in the dining room.</p>
          <p className="text-[#6d6661] font-light leading-relaxed mt-6 text-center max-w-2xl mx-auto">
            As a fine dining restaurant, proper attire is required. Please adhere to our policy if planning to have dinner at River Stone Chophouse. Casual attire is welcome in the lounge; hats are permitted in the lounge area only.
          </p>
        </Reveal>
        <div className="grid sm:grid-cols-2 gap-6 mt-14">
          <Reveal>
            <div className="bg-white border border-black/5 p-8 h-full">
              <h3 className="font-serif text-2xl text-[#1a1817] mb-5">We Suggest</h3>
              <ul className="space-y-3">
                {suggested.map((s) => (
                  <li key={s} className="flex items-center gap-3 text-[#3a3a3a] text-sm font-light">
                    <Check size={16} className="text-[#c5a059]" />{s}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="bg-white border border-black/5 p-8 h-full">
              <h3 className="font-serif text-2xl text-[#1a1817] mb-5">We Do Not Allow</h3>
              <ul className="space-y-3">
                {notAllowed.map((s) => (
                  <li key={s} className="flex items-center gap-3 text-[#3a3a3a] text-sm font-light">
                    <X size={16} className="text-[#C1272D]" />{s}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <p className="text-[#6d6661] font-light text-sm leading-relaxed mt-12 text-center max-w-2xl mx-auto">
            We reserve the right to refuse service to anyone that we do not deem to be wearing appropriate attire to dine in the restaurant.
          </p>
          <p className="font-serif italic text-lg text-[#1a1817] text-center mt-4">Thank you — Management</p>
          <div className="text-center mt-10"><LuxButton to="/reservations" variant="outline-dark" testid="dress-reserve">Reserve a Table</LuxButton></div>
        </Reveal>
      </div>
    </section>
  </main>
);

export default DressCodePage;
